import * as actionTypes from './actionTypes';

export const logInUser = (isAuthenticated, token, guid, userDetails, lastLogin, defaultLandingRoute) => ({
  type: actionTypes.USER_LOGGED_IN,
  isAuthenticated,
  token,
  guid,
  userDetails,
  lastLogin,
  defaultLandingRoute
})

export const logOutUser = () => ({
  type: actionTypes.USER_LOGGED_OUT
})



// WEBPACK FOOTER //
// ./src/actions/auth/index.js